import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import LogInButtons from 'flarum/forum/components/LogInButtons';
app.initializers.add('bydtalk-auth', () => {
  for (const [modal, fields] of Object.entries({
    LogInModal: ['identification', 'password'],
    SignUpModal: ['username', 'email', 'password'],
    ForgotPasswordModal: ['email']
  })) {
    const component = 'flarum/forum/components/' + modal;
    override(component, 'className', original => original() + ' BydTalkAuthModal');
    extend(component, 'fields', items => {
      for (const name of fields) {
        if (!items.has(name)) continue;
        const field = items.get(name);
        const input = field.children.find(child => child?.tag === 'input');
        if (!input) continue;
        const id = 'bt-' + modal + '-' + name;
        input.attrs.id = id;
        delete input.attrs.placeholder;
        if (name !== 'password') input.attrs.autocomplete = name === 'email' ? 'email' : 'username';
        const label = field.children.find(child => child?.tag === 'label');
        if (label) label.attrs.for = id;else field.children.unshift(m("label", {
          for: id
        }, input.attrs['aria-label']));
      }
    });
  }
  extend(LogInButtons.prototype, 'view', vnode => {
    if (vnode.children.length) vnode.children.push(m("div", {
      className: "BydTalkAuthDivider"
    }, m("span", null, app.translator.trans('bydtalk.forum.auth_or'))));
  });
});